import { PartsFilterModel } from './parts-filter.model';

export class PartsSearchModel {
  filterModel: PartsFilterModel;
  count: number;
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  results: any[];

  constructor() {
    this.filterModel = new PartsFilterModel();
    this.count = 0;
    this.totalCount = 0;
    this.pageNumber = 1;
    this.totalPages = 0;
    this.pageSize = 100;
    this.results = [];
  }
}
